import { sideBarNavigate } from "../partnerWeb_Dashboard/utils";
import { partnerApi } from "../../configs/api";
import { getAppHeader, RegexConfig } from "../../configs/config";
import { ACTION_ACCOUNT, PAN_TYPE } from "./types";
import { ROUTE } from "../../routes";
import { ButtonTypeTokens, InputStateToken, InputTypeToken, KeyboardTypeToken } from "@voltmoney/schema";
import md5 from 'md5';
let accountId;
let name;
let companyName;
let panNumber;
let arnNumber;
let ifscNumber;
let bankAccountNumber;
let gstNumber;
let panType;
let partnerName;
let detailsFor;
let reEnterBankAccountNumber;
let partnerCompanyName;
let partnerPanNumber;
let partnerArnNumber;
let partnerIfscNumber;
let partnerBankNumber;
let partnerGstNumber;
let partnerPanType;
let partnerPhoneNumber;
let partnerEmailId;
let partnerDetails;
let previewBankAccountNumber;
let password = '';
let confirmPassword = '';
let togglePassword = true;
let otherPANType = '';
let isGSTNumberValid = false;
let isPayoutEditClicked = false;
let isGSTPassed = false;
export const onChangeTab = async (action, _datastore, standardUtilities) => {
    await sideBarNavigate(standardUtilities, action);
};
export const onLoad = async (action, _datastore, { setDatastore, network }) => {
    const userContextResponse = await network.post(partnerApi.userContext, {}, { headers: await getAppHeader() });
    accountId = userContextResponse.data.linkedPartnerAccounts[0].accountId;
    const response = await network.get(`${partnerApi.clientList}${accountId}`, {
        headers: await getAppHeader(),
    });
    const partnerResponse = response?.data;
    partnerName = partnerResponse?.partnerName || "";
    partnerPhoneNumber = partnerResponse?.accountHolderPhoneNumber || "";
    partnerEmailId = partnerResponse?.accountHolderEmail || "";
    partnerCompanyName = partnerResponse?.partnerProfileDetails?.companyName || "";
    partnerArnNumber = partnerResponse?.partnerProfileDetails?.arnNo || "";
    partnerPanType = partnerResponse?.partnerProfileDetails?.panType || "";
    partnerGstNumber = partnerResponse?.partnerProfileDetails?.gstNo || "";
    partnerPanNumber = partnerResponse?.partnerProfileDetails?.panNo || "";
    partnerIfscNumber = partnerResponse?.partnerProfileDetails?.bankAccountIFSCCode || "";
    partnerBankNumber = partnerResponse?.partnerProfileDetails?.bankAccountNumber || "";
    partnerDetails = partnerResponse?.partnerProfileDetails?.detailsFor || "";
    await setDatastore(ROUTE.MY_ACCOUNT, "ctaSaveProfileDetailsButton", {
        type: ButtonTypeTokens.LargeOutline
    });
    await setDatastore(ROUTE.MY_ACCOUNT, "ctaSavePayoutDetailsButton", {
        type: ButtonTypeTokens.LargeOutline
    });
    await setDatastore(ROUTE.MY_ACCOUNT, "successPayoutCTA", {
        hide: true
    });
    await setDatastore(ROUTE.MY_ACCOUNT, "successCTA", {
        hide: true
    });
    await setDatastore(ROUTE.MY_ACCOUNT, "successPayoutCTASpace", {
        hide: true
    });
    await setDatastore(ROUTE.MY_ACCOUNT, "errorCTA", {
        hide: true
    });
    await setDatastore(ROUTE.MY_ACCOUNT, "errorCTASpace", {
        hide: true
    });
    await setDatastore(ROUTE.MY_ACCOUNT, "errorPayoutCTA", {
        hide: true
    });
    if (partnerPanType === "" && partnerPanNumber === "" && partnerGstNumber === "" && partnerBankNumber === "" && partnerIfscNumber === "" && partnerArnNumber === "") {
        await setDatastore(ROUTE.MY_ACCOUNT, "tabb", {
            active: 1
        });
        await setDatastore(ROUTE.MY_ACCOUNT, "payout_details_panInput", {
            state: InputStateToken.DEFAULT
        });
        const bankNumber = partnerBankNumber === null || partnerBankNumber === "null" ? '' : partnerBankNumber;
        await setDatastore(ROUTE.MY_ACCOUNT, "bankAccountInput", {
            state: InputStateToken.DEFAULT,
        });
        await setDatastore(ROUTE.MY_ACCOUNT, "successPayoutCTA", {
            hide: true
        });
        await setDatastore(ROUTE.MY_ACCOUNT, "successPayoutCTASpace", {
            hide: true
        });
        await setDatastore(ROUTE.MY_ACCOUNT, "bankAccountInput", {
            value: `${bankNumber}`
        });
        await setDatastore(ROUTE.MY_ACCOUNT, "reEnterBankInput", {
            state: InputStateToken.DEFAULT,
            value: `${partnerBankNumber ? partnerBankNumber : bankAccountNumber ? bankAccountNumber : ''}`
        });
        await setDatastore(ROUTE.MY_ACCOUNT, "panTypeInput", {
            label: `${panType ? panType : partnerPanType ? partnerPanType : 'Select PAN Type *'}`
        });
        await setDatastore(ROUTE.MY_ACCOUNT, "panTypeInput", {
            showEditable: true,
        });
        await setDatastore(ROUTE.MY_ACCOUNT, "ARNNumberInput", {
            state: InputStateToken.DEFAULT
        });
        await setDatastore(ROUTE.MY_ACCOUNT, "ifscInput", {
            state: InputStateToken.DEFAULT
        });
        await setDatastore(ROUTE.MY_ACCOUNT, "editPayoutDetailsSpace", {
            hide: true
        });
        await setDatastore(ROUTE.MY_ACCOUNT, "editPayoutDetailsStack", {
            hide: true
        });
        await setDatastore(ROUTE.MY_ACCOUNT, "ctaSavePayoutDetailsButtonStack", {
            hide: false
        });
        await setDatastore(ROUTE.MY_ACCOUNT, "reEnterBankStack", {
            hide: false
        });
        await setDatastore(ROUTE.MY_ACCOUNT, "reEnterBankSpaceStack", {
            hide: false
        });
        await setDatastore(ROUTE.MY_ACCOUNT, "panTypeShowStack", {
            hide: true
        });
        await setDatastore(ROUTE.MY_ACCOUNT, "panTypeStack", {
            hide: false
        });
        await setDatastore(ROUTE.MY_ACCOUNT, "detailsForShowSpace", {
            hide: true
        });
        await setDatastore(ROUTE.MY_ACCOUNT, "detailForShowStack", {
            hide: true
        });
    }
    else {
        await setDatastore(ROUTE.MY_ACCOUNT, "gstNumberInput", {
            state: InputStateToken.DISABLED
        });
    }
};
export const onEnteringProfileData = async (action, _datastore, { network, setDatastore }) => {
    switch (action.payload.widgetID) {
        case "name":
            name = action.payload.value;
            break;
        case "companyName":
            companyName = action.payload.value;
            break;
        case "arnNumber":
            arnNumber = action?.payload?.value;
            break;
        default:
            console.log("nothing came - default state");
            break;
    }
    if ((partnerName || name || arnNumber || companyName)) {
        await setDatastore(ROUTE.MY_ACCOUNT, "ctaSaveProfileDetailsButton", {
            type: ButtonTypeTokens.LargeFilled
        });
    }
    else {
        await setDatastore(ROUTE.MY_ACCOUNT, "ctaSaveProfileDetailsButton", {
            type: ButtonTypeTokens.LargeOutline
        });
    }
};
export const onEnteringPayoutDetails = async (action, _datastore, { setDatastore }) => {
    switch (action.payload.widgetID) {
        case "arnNumber":
            arnNumber = action.payload.value;
            break;
        case "ifscNumber":
            ifscNumber = action.payload.value;
            break;
        case "bankAccountNumber":
            bankAccountNumber = action.payload.value;
            break;
        case "gstNumber":
            gstNumber = action.payload.value;
            break;
        case "panNumber":
            panNumber = action.payload.value;
            break;
        case "reEnterBankAccountNumber":
            reEnterBankAccountNumber = action.payload.value;
            break;
        case "otherPANType":
            otherPANType = action.payload.value;
            break;
        default:
            console.log("onClickPayoutDetails nothing came here");
            break;
    }
    if ((partnerPanNumber && partnerIfscNumber && partnerPanType) === "") {
        isPayoutEditClicked = true;
    }
    if (!isPayoutEditClicked) {
        await setDatastore(ROUTE.MY_ACCOUNT, "payout_details_panInput", {
            state: InputStateToken.DISABLED
        });
        await setDatastore(ROUTE.MY_ACCOUNT, "gstNumberInput", {
            state: InputStateToken.DISABLED
        });
        await setDatastore(ROUTE.MY_ACCOUNT, "panTypeInput", {
            state: InputStateToken.DISABLED
        });
        await setDatastore(ROUTE.MY_ACCOUNT, "bankAccountInput", {
            state: InputStateToken.DISABLED
        });
        await setDatastore(ROUTE.MY_ACCOUNT, "reEnterBankInput", {
            state: InputStateToken.DISABLED
        });
        await setDatastore(ROUTE.MY_ACCOUNT, "ifscInput", {
            state: InputStateToken.DISABLED
        });
        await setDatastore(ROUTE.MY_ACCOUNT, "otherPanTypeInput", {
            state: InputStateToken.DISABLED
        });
    }
    else {
        const panRegex = new RegExp(RegexConfig.PAN);
        const isPanValied = panRegex.test(panNumber);
        if (panNumber.length > 0) {
            if (!isPanValied) {
                await setDatastore(ROUTE.MY_ACCOUNT, "payout_details_panInput", {
                    state: InputStateToken.ERROR,
                    caption: { error: 'Enter a valid PAN' },
                });
                await setDatastore(ROUTE.MY_ACCOUNT, "ctaSavePayoutDetailsButton", {
                    type: ButtonTypeTokens.LargeOutline
                });
                await setDatastore(ROUTE.MY_ACCOUNT, "gstNumberInput", {
                    state: InputStateToken.DISABLED
                });
            }
            else {
                await setDatastore(ROUTE.MY_ACCOUNT, "payout_details_panInput", {
                    state: InputStateToken.DEFAULT,
                    caption: { error: '', success: '' },
                });
                await setDatastore(ROUTE.MY_ACCOUNT, "gstNumberInput", {
                    state: InputStateToken.DEFAULT
                });
                if (reEnterBankAccountNumber.length > 0 && reEnterBankAccountNumber !== bankAccountNumber) {
                    await setDatastore(ROUTE.MY_ACCOUNT, "reEnterBankInput", {
                        state: InputStateToken.ERROR,
                        caption: { error: 'Account number does not match' },
                        showErrorOnFocus: true,
                        counter: Math.random()
                    });
                    await setDatastore(ROUTE.MY_ACCOUNT, "ctaSavePayoutDetailsButton", {
                        type: ButtonTypeTokens.LargeOutline
                    });
                }
                else {
                    await setDatastore(ROUTE.MY_ACCOUNT, "reEnterBankInput", {
                        state: InputStateToken.DEFAULT,
                        caption: { error: '' }
                    });
                }
                const ifscRegex = /^[A-Z]{4}0[A-Z0-9]{6}$/;
                if (ifscNumber.length > 0 && !ifscRegex.test(ifscNumber)) {
                    await setDatastore(ROUTE.MY_ACCOUNT, "ifscInput", {
                        state: InputStateToken.ERROR,
                        caption: { error: 'Please enter a valid IFSC number' },
                    });
                }
                else {
                    await setDatastore(ROUTE.MY_ACCOUNT, "ifscInput", {
                        state: InputStateToken.DEFAULT,
                        caption: { error: '' },
                    });
                }
                if (gstNumber !== undefined && gstNumber.length > 0 && gstNumber !== '') {
                    const gstNumberRegex = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;
                    if (gstNumber.includes(panNumber) && gstNumberRegex.test(gstNumber) && gstNumber.length === 15) {
                        isGSTNumberValid = true;
                        await setDatastore(ROUTE.MY_ACCOUNT, "gstNumberInput", {
                            state: InputStateToken.DEFAULT,
                            caption: { error: '' },
                        });
                    }
                    else {
                        await setDatastore(ROUTE.MY_ACCOUNT, "gstNumberInput", {
                            state: InputStateToken.ERROR,
                            caption: { error: 'Please enter a valid GST number' },
                        });
                        isGSTNumberValid = false;
                    }
                }
                else {
                    isGSTNumberValid = true;
                    await setDatastore(ROUTE.MY_ACCOUNT, "gstNumberInput", {
                        state: InputStateToken.DEFAULT,
                        caption: { error: '' },
                    });
                }
                if (gstNumber === '' || gstNumber === undefined) {
                    isGSTPassed = true;
                }
                else {
                    if (isGSTNumberValid) {
                        isGSTPassed = true;
                    }
                    else {
                        isGSTPassed = false;
                    }
                }
            }
        }
        else {
            await setDatastore(ROUTE.MY_ACCOUNT, "ctaSavePayoutDetailsButton", {
                type: ButtonTypeTokens.LargeOutline
            });
            await setDatastore(ROUTE.MY_ACCOUNT, "payout_details_panInput", {
                state: InputStateToken.DEFAULT,
                type: InputTypeToken.DEFAULT,
                caption: { error: '' },
            });
        }
        await setDatastore(ROUTE.MY_ACCOUNT, "bankAccountInput", {
            state: InputStateToken.DEFAULT
        });
        await setDatastore(ROUTE.MY_ACCOUNT, "reEnterBankInput", {
            state: InputStateToken.DEFAULT
        });
        await setDatastore(ROUTE.MY_ACCOUNT, "panTypeInput", {
            state: InputStateToken.DEFAULT
        });
        const isBankDetailsEntered = bankAccountNumber !== "" && reEnterBankAccountNumber !== undefined && (reEnterBankAccountNumber === bankAccountNumber);
        const isIFSCAvailable = (partnerIfscNumber || ifscNumber) && ifscNumber !== "" && ifscNumber !== null && ifscNumber !== undefined;
        const isPanValid = panNumber !== null && isPanValied;
        const isAllRequiredFieldEntered = (((partnerPanType || panType)
            && (partnerBankNumber || bankAccountNumber)
            && (partnerIfscNumber || ifscNumber)
            && (partnerPanNumber || panNumber))
            && isBankDetailsEntered
            && isIFSCAvailable
            && isPanValid && isGSTPassed);
        if (isAllRequiredFieldEntered) {
            await setDatastore(ROUTE.MY_ACCOUNT, "ctaSavePayoutDetailsButton", {
                type: ButtonTypeTokens.LargeFilled
            });
        }
        else {
            await setDatastore(ROUTE.MY_ACCOUNT, "ctaSavePayoutDetailsButton", {
                type: ButtonTypeTokens.LargeOutline
            });
        }
    }
};
export const onEnterArnDetails = async (action, _datastore, { setDatastore }) => {
    arnNumber = action?.payload?.value;
    await setDatastore(ROUTE.MY_ACCOUNT, "ARNNumberInput", {
        state: InputStateToken.DEFAULT,
        value: arnNumber || ''
    });
};
export const onSelectPanType = async (action, _datastore, { setDatastore }) => {
    panType = action.payload.value;
    if (panType === PAN_TYPE.OTHER) {
        await setDatastore(ROUTE.MY_ACCOUNT, "otherPanTypeInputStack", {
            hide: false
        });
        await setDatastore(ROUTE.MY_ACCOUNT, "otherPANInputSpaceStack", {
            hide: false
        });
    }
    else {
        await setDatastore(ROUTE.MY_ACCOUNT, "otherPanTypeInputStack", {
            hide: true
        });
        await setDatastore(ROUTE.MY_ACCOUNT, "otherPANInputSpaceStack", {
            hide: true
        });
    }
    await setDatastore(ROUTE.MY_ACCOUNT, "payout_details_panInput", {
        state: InputStateToken.DEFAULT,
    });
    const panRegex = new RegExp(RegexConfig.PAN);
    const isPanValied = panRegex.test(panNumber);
    await setDatastore(ROUTE.MY_ACCOUNT, "panTypeInput", {
        label: `${panType}`,
        showEditable: true,
        greyTitleColor: false
    });
    if (panNumber.length > 0) {
        if (!isPanValied) {
            await setDatastore(ROUTE.MY_ACCOUNT, "payout_details_panInput", {
                state: InputStateToken.ERROR,
                type: InputTypeToken.DEFAULT,
                caption: { error: 'Enter a valid PAN' }
            });
            await setDatastore(ROUTE.MY_ACCOUNT, "ctaSavePayoutDetailsButton", {
                type: ButtonTypeTokens.LargeOutline
            });
        }
        else {
            await setDatastore(ROUTE.MY_ACCOUNT, "payout_details_panInput", {
                state: InputStateToken.DEFAULT,
                type: InputTypeToken.DEFAULT,
                caption: { error: '', success: '' }
            });
        }
    }
    else {
        await setDatastore(ROUTE.MY_ACCOUNT, "payout_details_panInput", {
            state: InputStateToken.DEFAULT,
            type: InputTypeToken.DEFAULT,
            caption: { error: '', success: '' }
        });
    }
    const gstNumberRegex = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;
    if (gstNumber !== "") {
        if (gstNumber.includes(panNumber) && gstNumberRegex.test(gstNumber) && gstNumber.length === 15) {
            await setDatastore(ROUTE.MY_ACCOUNT, "gstNumberInput", {
                state: InputStateToken.DEFAULT,
                caption: { error: '' },
            });
            isGSTNumberValid = true;
        }
        else {
            await setDatastore(ROUTE.MY_ACCOUNT, "gstNumberInput", {
                state: InputStateToken.ERROR,
                caption: { error: 'Please enter a valid GST number' },
            });
            isGSTNumberValid = false;
        }
    }
    else {
        await setDatastore(ROUTE.MY_ACCOUNT, "gstNumberInput", {
            state: InputStateToken.DEFAULT,
            caption: { error: '' },
        });
    }
    if (reEnterBankAccountNumber !== undefined && reEnterBankAccountNumber !== bankAccountNumber) {
        await setDatastore(ROUTE.MY_ACCOUNT, "reEnterBankInput", {
            state: InputStateToken.ERROR,
            caption: { error: 'Account number does not match' }
        });
        await setDatastore(ROUTE.MY_ACCOUNT, "ctaSavePayoutDetailsButton", {
            type: ButtonTypeTokens.LargeOutline
        });
    }
    else {
        await setDatastore(ROUTE.MY_ACCOUNT, "reEnterBankInput", {
            state: InputStateToken.DEFAULT,
            caption: { error: '' }
        });
    }
    const isBankDetailsEntered = bankAccountNumber !== "" && reEnterBankAccountNumber !== undefined && (reEnterBankAccountNumber === bankAccountNumber);
    const isIFSCAvailable = (partnerIfscNumber || ifscNumber) && ifscNumber !== "" && ifscNumber !== null && ifscNumber !== undefined;
    const isPanValid = panNumber !== null && isPanValied;
    const isAllRequiredFieldEntered = ((partnerPanType || panType) && (partnerBankNumber || bankAccountNumber) && (partnerIfscNumber || ifscNumber) && (partnerPanNumber || panNumber));
    if (isAllRequiredFieldEntered && isBankDetailsEntered && isIFSCAvailable && isPanValid) {
        await setDatastore(ROUTE.MY_ACCOUNT, "ctaSavePayoutDetailsButton", {
            type: ButtonTypeTokens.LargeFilled
        });
    }
    else {
        await setDatastore(ROUTE.MY_ACCOUNT, "ctaSavePayoutDetailsButton", {
            type: ButtonTypeTokens.LargeOutline
        });
    }
};
export const onSaveProfileDetails = async (action, _datastore, { network, setDatastore, instrumentTrack, addUseProperty }) => {
    const updateDetails = {
        partnerName: name,
        partnerProfileDetails: {
            companyName: companyName ? companyName : '',
            arnNo: arnNumber ? arnNumber : ''
        }
    };
    await setDatastore(ROUTE.MY_ACCOUNT, "successPayoutCTA", {
        hide: true
    });
    await setDatastore(ROUTE.MY_ACCOUNT, "successPayoutCTASpace", {
        hide: true
    });
    const response = await network.patch(`${partnerApi.accountAttributes}${accountId}`, updateDetails, { headers: await getAppHeader() });
    if (response.status === 200) {
        await setDatastore(ROUTE.MY_ACCOUNT, "ctaSavePayoutDetailsButton", {
            type: ButtonTypeTokens.LargeOutline
        });
        await setDatastore(ROUTE.MY_ACCOUNT, "companyNameInput", {
            value: `${companyName === null || companyName === "null" || companyName === undefined ? '' : companyName}`
        });
        await setDatastore(ROUTE.MY_ACCOUNT, "ARNNumberInput", {
            value: `${arnNumber === null || arnNumber === "null" || arnNumber === undefined ? '' : arnNumber}`
        });
        await setDatastore(ROUTE.MY_ACCOUNT, "ARNNumberInput", {
            state: InputStateToken.DISABLED,
        });
        await setDatastore(ROUTE.MY_ACCOUNT, "companyNameInput", {
            state: InputStateToken.DISABLED,
        });
        await setDatastore(ROUTE.MY_ACCOUNT, "nameInput", {
            state: InputStateToken.DISABLED
        });
        await setDatastore(ROUTE.MY_ACCOUNT, "ctaSaveProfileStack", {
            hide: true
        });
        await setDatastore(ROUTE.MY_ACCOUNT, "editProfileButtonStack", {
            hide: false
        });
        await setDatastore(ROUTE.MY_ACCOUNT, "editButtonSpace", {
            hide: false
        });
        await setDatastore(ROUTE.MY_ACCOUNT, "panTypeStack", {
            state: InputStateToken.DISABLED
        });
        await setDatastore(ROUTE.MY_ACCOUNT, "successCTA", {
            hide: false
        });
        await setDatastore(ROUTE.MY_ACCOUNT, "errorCTA", {
            hide: true
        });
        await setDatastore(ROUTE.MY_ACCOUNT, "errorCTASpace", {
            hide: true
        });
        instrumentTrack("EDIT_PROFILE_SUCCESS", {
            "status": true,
        });
        addUseProperty("name", name);
        addUseProperty("company_name", companyName);
    }
    else {
        await setDatastore(ROUTE.MY_ACCOUNT, "errorCTA", {
            hide: false
        });
        await setDatastore(ROUTE.MY_ACCOUNT, "errorCTASpace", {
            hide: false
        });
    }
};
export const onSavePayoutDetails = async (action, _datastore, { network, setDatastore, instrumentTrack, addUseProperty }) => {
    isPayoutEditClicked = false;
    const response = await network.patch(`${partnerApi.accountAttributes}${accountId}`, {
        partnerProfileDetails: {
            panType: panType !== undefined ? panType : partnerPanType,
            panNo: panNumber,
            gstNo: gstNumber,
            bankAccountIFSCCode: ifscNumber,
            arnNo: arnNumber,
            detailsFor: detailsFor,
            bankAccountNumber: bankAccountNumber,
            otherPanTypeDetail: otherPANType !== undefined || otherPANType !== '' ? otherPANType : ''
        }
    }, { headers: await getAppHeader() });
    if (response?.status === 200) {
        instrumentTrack("PAYOUT_DETAILS_ADDED", {
            "status": true,
        });
        addUseProperty("pan_type", panType);
        addUseProperty("added_details_for", detailsFor && detailsFor);
        addUseProperty("gst_number", gstNumber);
        addUseProperty("arn_number", arnNumber);
        previewBankAccountNumber = bankAccountNumber === null || bankAccountNumber === "null" ? '' : bankAccountNumber;
        await setDatastore(ROUTE.MY_ACCOUNT, "ARNNumberInput", {
            state: InputStateToken.DISABLED,
            value: arnNumber || ''
        });
        await setDatastore(ROUTE.MY_ACCOUNT, "ifscInput", {
            state: InputStateToken.DISABLED,
            value: ifscNumber
        });
        await setDatastore(ROUTE.MY_ACCOUNT, "payout_details_panInput", {
            state: InputStateToken.DISABLED,
        });
        await setDatastore(ROUTE.MY_ACCOUNT, "payout_details_panInput", {
            value: panNumber,
        });
        await setDatastore(ROUTE.MY_ACCOUNT, "otherPanTypeInput", {
            state: InputStateToken.DISABLED,
        });
        await setDatastore(ROUTE.MY_ACCOUNT, "otherPanTypeInput", {
            value: otherPANType,
        });
        await setDatastore(ROUTE.MY_ACCOUNT, "gstNumberInput", {
            state: InputStateToken.DISABLED,
            type: InputTypeToken.DEFAULT,
            value: gstNumber || ''
        });
        await setDatastore(ROUTE.MY_ACCOUNT, "editPayoutDetailsSpace", {
            hide: false
        });
        await setDatastore(ROUTE.MY_ACCOUNT, "editPayoutDetailsStack", {
            hide: false
        });
        await setDatastore(ROUTE.MY_ACCOUNT, "ctaSavePayoutDetailsButtonStack", {
            hide: true
        });
        await setDatastore(ROUTE.MY_ACCOUNT, "reEnterBankStack", {
            hide: true
        });
        await setDatastore(ROUTE.MY_ACCOUNT, "reEnterBankSpaceStack", {
            hide: true
        });
        await setDatastore(ROUTE.MY_ACCOUNT, "successPayoutCTA", {
            hide: false
        });
        await setDatastore(ROUTE.MY_ACCOUNT, "successPayoutCTASpace", {
            hide: false
        });
        const bankAccountWithAsterisk = bankAccountNumber.replace(/./g, '*');
        await setDatastore(ROUTE.MY_ACCOUNT, "bankAccountInput", {
            state: InputStateToken.DISABLED,
            value: `${bankAccountNumber === null || bankAccountNumber === "null" ? '' : bankAccountWithAsterisk}`
        });
        await setDatastore(ROUTE.MY_ACCOUNT, "errorPayoutCTA", {
            hide: true
        });
        await setDatastore(ROUTE.MY_ACCOUNT, "successPayoutCTASpace", {
            hide: true
        });
        const userContextResponse = await network.post(partnerApi.userContext, {}, { headers: await getAppHeader() });
        accountId = userContextResponse.data.linkedPartnerAccounts[0].accountId;
        const response = await network.get(`${partnerApi.clientList}${accountId}`, {
            headers: await getAppHeader(),
        });
        const partnerResponse = response.data;
        partnerName = partnerResponse.partnerName;
        partnerPhoneNumber = partnerResponse.accountHolderPhoneNumber;
        partnerEmailId = partnerResponse.accountHolderEmail;
        partnerCompanyName = partnerResponse.partnerProfileDetails.companyName;
        partnerArnNumber = partnerResponse.partnerProfileDetails.arnNo;
        partnerPanType = partnerResponse.partnerProfileDetails.panType;
        partnerGstNumber = partnerResponse.partnerProfileDetails.gstNo;
        partnerPanNumber = partnerResponse.partnerProfileDetails.panNo;
        partnerIfscNumber = partnerResponse.partnerProfileDetails.bankAccountIFSCCode;
        partnerBankNumber = partnerResponse.partnerProfileDetails.bankAccountNumber;
        partnerDetails = partnerResponse.partnerProfileDetails.detailsFor;
        addUseProperty("pan_type", panType);
        addUseProperty("added_details_for", detailsFor && detailsFor);
        addUseProperty("gst_number", gstNumber);
        addUseProperty("arn_number", arnNumber);
    }
    else {
        await setDatastore(ROUTE.MY_ACCOUNT, "errorPayoutCTA", {
            hide: false
        });
        await setDatastore(ROUTE.MY_ACCOUNT, "successPayoutCTASpace", {
            hide: false
        });
        instrumentTrack("PAYOUT_DETAILS_ADDED", {
            "status": false,
            "reason": response.status
        });
    }
};
export const onEditProfileDetails = async (action, _datastore, { network, setDatastore }) => {
    await setDatastore(ROUTE.MY_ACCOUNT, "companyNameInput", {
        state: InputStateToken.DEFAULT,
    });
    await setDatastore(ROUTE.MY_ACCOUNT, "companyNameInput", {
        value: `${companyName === null || companyName === "null" || companyName === undefined ? '' : companyName}`
    });
    await setDatastore(ROUTE.MY_ACCOUNT, "nameInput", {
        state: InputStateToken.DEFAULT
    });
    await setDatastore(ROUTE.MY_ACCOUNT, "ARNNumberInput", {
        value: `${arnNumber === null || arnNumber === "null" || arnNumber === undefined ? '' : arnNumber}`
    });
    await setDatastore(ROUTE.MY_ACCOUNT, "ARNNumberInput", {
        state: InputStateToken.DEFAULT
    });
    await setDatastore(ROUTE.MY_ACCOUNT, "ctaSaveProfileStack", {
        hide: false
    });
    await setDatastore(ROUTE.MY_ACCOUNT, "editProfileButtonStack", {
        hide: true
    });
    await setDatastore(ROUTE.MY_ACCOUNT, "editButtonSpace", {
        hide: true
    });
    await setDatastore(ROUTE.MY_ACCOUNT, "successCTA", {
        hide: true
    });
    if ((partnerName && partnerPhoneNumber && partnerEmailId) || (partnerArnNumber || partnerCompanyName)) {
        await setDatastore(ROUTE.MY_ACCOUNT, "ctaSaveProfileDetailsButton", {
            type: ButtonTypeTokens.LargeFilled
        });
    }
    else {
        await setDatastore(ROUTE.MY_ACCOUNT, "ctaSaveProfileDetailsButton", {
            type: ButtonTypeTokens.LargeOutline
        });
    }
};
export const onEditPayoutDetails = async (action, _datastore, { network, setDatastore }) => {
    isPayoutEditClicked = true;
    const bankNumber = partnerBankNumber === null || partnerBankNumber === "null" ? '' : partnerBankNumber;
    await setDatastore(ROUTE.MY_ACCOUNT, "payout_details_panInput", {
        state: InputStateToken.DEFAULT
    });
    await setDatastore(ROUTE.MY_ACCOUNT, "gstNumberInput", {
        state: InputStateToken.DEFAULT,
        isFocus: true
    });
    await setDatastore(ROUTE.MY_ACCOUNT, "panTypeInput", {
        state: InputStateToken.DEFAULT,
        label: `${panType ? panType : partnerPanType ? partnerPanType : 'Select PAN Type *'}`,
        showEditable: true,
        greyTitleColor: true
    });
    await setDatastore(ROUTE.MY_ACCOUNT, "bankAccountInput", {
        state: InputStateToken.DEFAULT,
    });
    await setDatastore(ROUTE.MY_ACCOUNT, "bankAccountInput", {
        value: `${bankNumber}`,
    });
    await setDatastore(ROUTE.MY_ACCOUNT, "reEnterBankInput", {
        state: InputStateToken.DEFAULT,
    });
    await setDatastore(ROUTE.MY_ACCOUNT, "reEnterBankInput", {
        value: `${partnerBankNumber ? partnerBankNumber : bankAccountNumber ? bankAccountNumber : ''}`
    });
    await setDatastore(ROUTE.MY_ACCOUNT, "ifscInput", {
        state: InputStateToken.DEFAULT
    });
    await setDatastore(ROUTE.MY_ACCOUNT, "ARNNumberInput", {
        state: InputStateToken.DEFAULT
    });
    await setDatastore(ROUTE.MY_ACCOUNT, "otherPanTypeInput", {
        state: InputStateToken.DEFAULT
    });
    await setDatastore(ROUTE.MY_ACCOUNT, "successPayoutCTA", {
        hide: true
    });
    await setDatastore(ROUTE.MY_ACCOUNT, "successPayoutCTASpace", {
        hide: true
    });
    await setDatastore(ROUTE.MY_ACCOUNT, "editPayoutDetailsSpace", {
        hide: true
    });
    await setDatastore(ROUTE.MY_ACCOUNT, "editPayoutDetailsStack", {
        hide: true
    });
    await setDatastore(ROUTE.MY_ACCOUNT, "ctaSavePayoutDetailsButtonStack", {
        hide: false
    });
    await setDatastore(ROUTE.MY_ACCOUNT, "reEnterBankStack", {
        hide: false
    });
    await setDatastore(ROUTE.MY_ACCOUNT, "reEnterBankSpaceStack", {
        hide: false
    });
    await setDatastore(ROUTE.MY_ACCOUNT, "panTypeShowStack", {
        hide: true
    });
    await setDatastore(ROUTE.MY_ACCOUNT, "panTypeStack", {
        hide: false
    });
    await setDatastore(ROUTE.MY_ACCOUNT, "detailsForShowSpace", {
        hide: true
    });
    await setDatastore(ROUTE.MY_ACCOUNT, "detailForShowStack", {
        hide: true
    });
};
export const onSetNewPassword = async (action, _datastore, { setDatastore, instrumentTrack }) => {
    const passwordHash = action.payload.value;
    instrumentTrack("SET_PASSWORD_BUTTON_CLICKED");
    await setDatastore(ROUTE.MY_ACCOUNT, "space32Stack", {
        hide: true,
    });
    await setDatastore(ROUTE.MY_ACCOUNT, "showMobileInputStack", {
        hide: false,
    });
    await setDatastore(ROUTE.MY_ACCOUNT, "savePasswordStack", {
        hide: false,
    });
    await setDatastore(ROUTE.MY_ACCOUNT, "createPasswordStack", {
        hide: true,
    });
    await setDatastore(ROUTE.MY_ACCOUNT, "setNewPasswordStack", {
        hide: true,
    });
    await setDatastore(ROUTE.MY_ACCOUNT, "createPasswordInput", {
        state: InputStateToken.DEFAULT,
        keyboardType: KeyboardTypeToken.default
    });
    await setDatastore(ROUTE.MY_ACCOUNT, "createPasswordInput", {
        placeholder: 'Enter new password',
    });
    if (password !== '') {
        await setDatastore(ROUTE.MY_ACCOUNT, "saveLoginDetails", {
            type: ButtonTypeTokens.LargeFilled
        });
    }
    else {
        await setDatastore(ROUTE.MY_ACCOUNT, "saveLoginDetails", {
            type: ButtonTypeTokens.LargeOutline
        });
    }
};
export const toggleAction = async (action, _datastore, { setDatastore }) => {
    if (togglePassword) {
        togglePassword = false;
    }
    else {
        togglePassword = true;
    }
    await setDatastore(ROUTE.MY_ACCOUNT, "reEnterPasswordInput", {
        state: InputStateToken.DEFAULT,
        showPasswordIcon: true,
        togglePasswordIcon: togglePassword,
        toggleAction: {
            routeId: ROUTE.MY_ACCOUNT,
            type: ACTION_ACCOUNT.TOGGLE_PASSWORD
        },
        secureTextEntry: togglePassword
    });
    console.warn('**** onKnowMore leads Action Triggered ****', action);
};
export const getReEnteredPassword = async (action, _datastore, { setDatastore }) => {
    confirmPassword = action.payload.value;
    if (confirmPassword !== '' && password !== '' && confirmPassword === password) {
        await setDatastore(ROUTE.MY_ACCOUNT, "saveLoginDetails", {
            type: ButtonTypeTokens.LargeFilled
        });
    }
    else {
        await setDatastore(ROUTE.MY_ACCOUNT, "saveLoginDetails", {
            type: ButtonTypeTokens.LargeOutline
        });
    }
    if (confirmPassword && password !== confirmPassword) {
        await setDatastore(ROUTE.MY_ACCOUNT, "reEnterPasswordInput", {
            state: InputStateToken.ERROR,
            caption: { error: "Password doesn't match" }
        });
    }
    else {
        await setDatastore(ROUTE.MY_ACCOUNT, "reEnterPasswordInput", {
            state: InputStateToken.DEFAULT,
            caption: { error: "" }
        });
    }
};
export const getEnteredPassword = async (action, _datastore, { setDatastore }) => {
    password = action.payload.value;
    if (confirmPassword !== '' && password !== '' && confirmPassword === password) {
        await setDatastore(ROUTE.MY_ACCOUNT, "saveLoginDetails", {
            type: ButtonTypeTokens.LargeFilled
        });
    }
    else {
        await setDatastore(ROUTE.MY_ACCOUNT, "saveLoginDetails", {
            type: ButtonTypeTokens.LargeOutline
        });
    }
    if (confirmPassword && password !== confirmPassword) {
        await setDatastore(ROUTE.MY_ACCOUNT, "reEnterPasswordInput", {
            state: InputStateToken.ERROR,
            caption: { error: "Password doesn't match" }
        });
    }
    else {
        await setDatastore(ROUTE.MY_ACCOUNT, "reEnterPasswordInput", {
            state: InputStateToken.DEFAULT,
            caption: { error: "" }
        });
    }
};
export const sendPasswordToBackend = async (action, _datastore, { navigate, network, setDatastore }) => {
    const userContextResponse = await network.post(partnerApi.userContext, {}, { headers: await getAppHeader() });
    const accountId = userContextResponse?.data?.linkedPartnerAccounts[0]?.accountId;
    const passwordMD5 = md5(password);
    const accountAttributeResponse = await network.patch(`${partnerApi.accountAttribute}${accountId}`, {
        passwordHash: passwordMD5
    }, { headers: await getAppHeader() });
    if (accountAttributeResponse.status === 200) {
        password = '';
        confirmPassword = '';
        await setDatastore(ROUTE.MY_ACCOUNT, "loginSuccessCTA", {
            hide: false
        });
        setTimeout(async () => {
            await setDatastore(ROUTE.MY_ACCOUNT, "loginSuccessCTA", {
                hide: true
            });
        }, 3000);
        await setDatastore(ROUTE.MY_ACCOUNT, "showMobileInputStack", {
            hide: true,
        });
        await setDatastore(ROUTE.MY_ACCOUNT, "space32Stack", {
            hide: false,
        });
        await setDatastore(ROUTE.MY_ACCOUNT, "savePasswordStack", {
            hide: true,
        });
        await setDatastore(ROUTE.MY_ACCOUNT, "createPasswordStack", {
            hide: true,
        });
        await setDatastore(ROUTE.MY_ACCOUNT, "setNewPasswordStack", {
            hide: false,
        });
        await setDatastore(ROUTE.MY_ACCOUNT, "setNewPasswordButton", {
            label: 'Change password'
        });
    }
    else {
        await setDatastore(ROUTE.MY_ACCOUNT, "showMobileInputStack", {
            hide: false,
        });
        await setDatastore(ROUTE.MY_ACCOUNT, "savePasswordStack", {
            hide: false,
        });
        await setDatastore(ROUTE.MY_ACCOUNT, "createPasswordStack", {
            hide: true,
        });
        await setDatastore(ROUTE.MY_ACCOUNT, "space32Stack", {
            hide: true,
        });
    }
};
export const openMenu = async (action, _datastore, { navigate }) => {
    console.warn('**** onKnowMore leads Action Triggered ****', action);
    await navigate(ROUTE.PARTNER_MENU, {
        routeId: action.routeId
    });
};
export const navigateToPayoutDetails = async (action, _datastore, { navigate }) => {
    const panType = action?.payload?.panType;
    const panNumber = action?.payload?.panNumber;
    const gstNumber = action?.payload?.gstNumber;
    const bankAccountNumber = action?.payload?.bankAccountNumber;
    const ifscCode = action?.payload?.ifscCode;
    await navigate(ROUTE.PAYOUT_DETAILS_SCREEN, {
        panType,
        panNumber,
        gstNumber,
        bankAccountNumber,
        ifscCode,
    });
};
